import { EXTERNAL_ROL, BASE_HREF, NUM_FILE_TABLE, FILE_TABLE_DEF, LINKS_EXTERNAL, ROOT_EXTERNA, FILE_TABLE, NUM_FILE_TABLE_OPTIONS} from '../../../../../core/utils/constants';
import { WebservicesParse } from 'src/app/core/entities/webservicesparse.model';
import { DataExternal } from 'src/app/core/entities/dataexternal.model';
import { WebserviceValorDato } from 'src/app/core/entities/webservicevalordato.model';
import { Wsdefs } from 'src/app/core/entities/wsdefs.model';
import { DialogsDatoswsComponent } from 'src/app/shared/components/dialogs/dialogs-datosws/dialogs-datosws.component';
import { DialogsAlertComponent } from '../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { HomeExternalService } from './../../../shared/home/home-external.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { registerLocaleData, Location } from '@angular/common';
import { Component, OnInit, ViewChild} from '@angular/core';
import { NgForm } from '@angular/forms';
import es from '@angular/common/locales/es';
import * as _ from 'lodash';

@Component({
  selector: 'app-home-proveedor',
  templateUrl: '../../../shared/home/home-external.component.html',
  styleUrls: ['../../../shared/home/home-external.component.scss']
})
export class HomeProveedorComponent implements OnInit {

  /** Rutas a imagenes de ws parte externa proveedores */
  readonly SALIR: String = BASE_HREF + '/assets/images/logout.svg';
  readonly AYUDA: String = BASE_HREF + '/assets/images/help-btn.svg';
  readonly CARET: String = BASE_HREF + '/assets/images/small-caret-up.svg';
  readonly DOWNLOAD: String = BASE_HREF + '/assets/images/download-w.svg';
  readonly DOWNLOAD_ARROW: String = BASE_HREF + '/assets/images/download-arrow.svg';
  readonly UP_CHEVRON: String = BASE_HREF + '/assets/images/up-chevron.svg';
  readonly DOWN_ARROW: String = BASE_HREF + '/assets/images/down-arrow.svg';
  readonly IMG_PREHOME: string = BASE_HREF + '/assets/images/carpetaEstalviaTemps.jpg';

  /**rutas externas a webs y servicios de Reus */
  readonly REUS_INFO: String = LINKS_EXTERNAL.REUS_INFO;
  readonly REUS_REQUISITOS: String = LINKS_EXTERNAL.REUS_REQUISITOS;
  readonly REUS_REQUISITOS_GUIA: String = LINKS_EXTERNAL.REUS_REQUISITOS_GUIA;
  readonly REUS_INCIDENCIAS: String = LINKS_EXTERNAL.REUS_INCIENCIAS;
  readonly REUS_AVISOS: String = LINKS_EXTERNAL.REUS_AVISOS;

  @ViewChild('f', {static: true})
  form!: NgForm;
  data: any;

  loadingTotal: boolean = true;
  loading: boolean = false;
  loadingWSEnabled: boolean = true;
  posicionY: number = 0;
  error: boolean = false;

  numFilas: any[] = NUM_FILE_TABLE;
  numeroFilas : number = FILE_TABLE_DEF;

  ClickedRow:any;

  responsiveOptions = [
    {
        breakpoint: '1024px',
        numVisible: 3,
        numScroll: 3
    },
    {
        breakpoint: '768px',
        numVisible: 2,
        numScroll: 2
    },
    {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1
    }
  ];

  constructor(public homeExtService: HomeExternalService,
              private translateService: TranslateService,
              private dialog: MatDialog,
              private router: Router,
              private location: Location) {
                //this.data = this.router.getCurrentNavigation().extras.state;
                this.data = this.location.getState();
                this.ClickedRow = function(index : any){  
                  let datosWs = new Array<WebserviceValorDato>();
                  datosWs = _.cloneDeep(index);
                  this.dialogoValorWS(datosWs);
                } 
              }

  ngOnInit() {
    registerLocaleData(es);
    this.numFilasCombo();
    this.error = false;
    this.loadingTotal = true;
    this.loading = false;
    this.loadingWSEnabled = false;
    this.homeExtService.loadingWS = false;
    if(this.data != undefined){
      let objetoexternal = new DataExternal();
      objetoexternal.dboid = _.cloneDeep(this.data.dataexternal.dboid);
      objetoexternal.tercer = _.cloneDeep(this.data.dataexternal.tercer);
      objetoexternal.representant = _.cloneDeep(this.data.dataexternal.representant);
      objetoexternal.representants = _.cloneDeep(this.data.dataexternal.representants);
      objetoexternal.representantAOC = _.cloneDeep(this.data.dataexternal.representantAOC);
      objetoexternal.representantsAOC = _.cloneDeep(this.data.dataexternal.representantsAOC);
      this.homeExtService.initView(EXTERNAL_ROL.PAGES.proveedor,  objetoexternal).subscribe(res => {
        console.log(res);
        this.error = false;
        this.loadingTotal = false;
        this.loading = false;
      }, error => {
        this.router.navigate(['/external/proveidors/acces']);
        this.error = true;
        this.loadingTotal = false;
        this.loading = false;
        this.errorCargaWS('WARNINGS.error_ws');
        console.log("Error: " + error);
      });
    }else{
      this.router.navigate(['/external/proveidors/acces']);
      this.error = true;
      this.loadingTotal = false;
      this.loading = false;
    }
  }

  /**
  * @description
  * Cambia a valor numérico el check para elegir nº columnas tablas
  * @param error numero columnas
  */
  public retornarNumFilas(dato: string):number{
    this.numeroFilas = +dato;
    return this.numeroFilas;
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorCargaWS(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  /**
  * @description
  * Lanza la llamada al WS seleccionado por el cliente
  * @param dato Webservice a mostrar
  * @param posicionA Posicion que ocupa el setvalue seleccionado
  * @param posicionB Posicion que ocupa el ws seleccionado
  */
  public recogerWS(dato: Wsdefs, posicionA: number, posicionB: number, actPosic: number, evento: any){

    this.numeroFilas = FILE_TABLE_DEF;
    this.numFilasDefecto();

    /**Tenemos en cuenta Avisos y Anotaciones para el posicionamiento de las tablas de los WS al pulsar el elemento**/
    let valorNota : number = 0;
    let valorAviso : number = 0;
    let nota = document.getElementById('notaExter');
    let aviso = document.getElementById('avisoExter');
    if(nota){
      valorNota = nota.getBoundingClientRect().height;
    }
    if(aviso){
      valorAviso = aviso.getBoundingClientRect().height;
    }

    /**En dispositivos móviles siempre después de pulsar una opción el menu se plegará**/
    let menuAbrir = document.getElementById("collapseOne");
    let menuCerrar = document.getElementById("menumovilCerrar");

    if (menuAbrir && menuCerrar) {
      if(window.screen.width < 500){
        menuAbrir.style.display = "none";
        menuCerrar.style.display = "block";
        this.posicionY = 0;
        window.scrollTo(0, 0);
      }else{

        menuAbrir.style.display = "";
        menuCerrar.style.display = "";

        if(actPosic === 0){
          this.posicionY = evento.pageY - 345 - valorNota - valorAviso;
          window.scrollTo(0, this.posicionY);
        }else{
          window.scrollTo(0, 0);
          this.posicionY = 0;
        }
      }
    }

    /**Si el WS esta activado dependerá si refrescamos o no para pasar por el subscribe*/
    if(dato?.xmldef?.code == this.homeExtService.linkexter){
      this.homeExtService.accederGTT(dato, '');
    }else{
      if (dato.enable === 1) {
          this.loadingWSEnabled = true;
          this.homeExtService.recogerWSEnable(dato, posicionA, posicionB).subscribe(res => {
              console.log(res);
              this.error = false;
              this.loadingWSEnabled = false;
          }, error => {
              this.error = true;
              this.loadingWSEnabled = false;
              this.errorCargaWS('WARNINGS.error_ws');
              console.log("Error: " + error);
          });

      /**Si el WS esta desactivado tendremos que ir a buscar los datos */
      } else {
          this.loadingWSEnabled = true;
          this.homeExtService.recogerWS(dato, posicionA, posicionB).subscribe(res => {
              console.log(res);
              this.error = false;
              this.loadingWSEnabled = false;
          }, error => {
              this.error = true;
              this.loadingWSEnabled = false;
              this.errorCargaWS('WARNINGS.error_ws');
              console.log("Error: " + error);
          });
      }
    }
  }

  /**
  * @description
  * Lanza la llamada al WS seleccionado por el cliente al refrescar datos
  * @param dato Webservice a mostrar
  */
  public recogerWSRefres(dato: Wsdefs){
    console.log(this.homeExtService.webservicesParse);
    if(dato.enable == 0){
      for(let i = 0; i < this.homeExtService.webservicesParse.length; i++){
        if(this.homeExtService.webservicesParse[i].code == dato.code){
          this.homeExtService.webservicesParse.splice(i, 1);
        }
      }
    }
  }

  /**
  * @description
  * Lanza la llamada al WS seleccionado por el cliente al refrescar datos en las tablas
  * @param dato WebservicesParse de la tabla
  */
  public recogerWSTabla(dato: WebservicesParse){

    this.numeroFilas = FILE_TABLE_DEF;
    this.numFilasDefecto();
    let ws = new Wsdefs();
    for(let i = 0; i < this.homeExtService.wsdefs.length; i++){
      if(this.homeExtService.wsdefs[i].code == dato.code){
        ws = _.cloneDeep(this.homeExtService.wsdefs[i]);
      }
    }

    this.loadingWSEnabled = true;
    this.homeExtService.recogerWSObservable(ws).subscribe(res => {
      console.log(res);
      this.error = false;
      this.loadingWSEnabled = false;
    }, error => {
      this.error = true;
      this.loadingWSEnabled = false;
      this.errorCargaWS('WARNINGS.error_ws');
      console.log("Error: " + error);
    });
  }

  /**
  * @description
  * función creada para adaptar la funcion recogerWS con el codigo del ws
  * @param dato CODIGO
  * @param posicionA Posicion que ocupa el setvalue seleccionado
  * @param posicionB Posicion que ocupa el ws seleccionado
  */
  public recogerWSBuscador(code: string, posicionA: number, posicionB: number, actPosic: number, evento: any){
    let ws = new Wsdefs();
    for(let i = 0; i < this.homeExtService.wsdefsrol.length; i++){
      if(this.homeExtService.wsdefsrol[i].code === code){
        ws = _.cloneDeep(this.homeExtService.wsdefsrol[i]);
      }
    }
    this.recogerWS(ws, posicionA, posicionB, actPosic, evento);
  }

  /**
  * @description
  * Comprueba si el valor del dato coincide con su etiqueta y correspondiente tipado del mismo
  * @param item1 Posicion que ocupan los valores del WS
  * @param item2 Posicion que ocupa el formato del valor seleccionado
  * @param error Verdadero o Falso
  */
  public tipadoRegistros(item1: number, item2: number){
    if(item1 == item2){
      return true;
    }else{
      return false;
    }
  }

  /**
  * @description
  * Cerramos el banner que aparece cuando cargamos la página
  */
  public onCloseClick(){
    this.homeExtService.notices.enable = 0;
  }

  /**
  * @description
  * Redirigimos al servidor para que nor ordene las columnas de las tablas de los ws
  * @param text code de la etiqueta para identificar la columna que hemos pulsado a ordenar
  * @param numero botón al que pulsamos (1 - orden ascendente; 2 - orden descendente)
  */
  public ordenarColumnas(text: any, numero: number) {
    this.homeExtService.ordenarColumnas(text, numero);
  }

  /**
  * @description
  * Saca un Cuadro de dialogo al pulsar una fila de la tabla con los datos del WS
  * @param datos datos del ws seleccionado en la tabla
  */
  public dialogoValorWS(datos: Array<WebserviceValorDato>) {

    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";

    let wscode = this.homeExtService.webserviceVista.code;
    let cat = this.homeExtService.webserviceVista.cat;
    let esp = this.homeExtService.webserviceVista.esp;
    let etiquetas = this.homeExtService.webserviceVista.etiquetas;
    let wscodexml = this.homeExtService.webserviceVista.codXmldef;
    let entorno = ROOT_EXTERNA;

    const dialogRef = this.dialog.open(DialogsDatoswsComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      autoFocus: false,
      data: { datos, wscode, cat, esp, etiquetas, wscodexml, entorno }
    });
    dialogRef.afterClosed();
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar error que no hay listado a exportar
  */
  public exportarDatos(){
    let forzarerror = this.homeExtService.exportarDatos();
    if(forzarerror == 0){
      this.errorCargaWS("WARNINGS.error_data_export");
    }
  }

  /**
  * @description
  * Según resolución de pantalla se insertará por defecto el numero de filas visibles en las tablas
  */
  public numFilasDefecto(){

    let resolucion = window.screen.width;
      
    if(resolucion < 500){
      this.numeroFilas = FILE_TABLE.MOVIL;
    } else if(resolucion > 500 && resolucion < 750) {
      this.numeroFilas = FILE_TABLE.TABLET;
    } else{
      this.numeroFilas = FILE_TABLE.PC;
    }
  }

  /**
  * @description
  * Según resolución de pantalla se elegirá un tipo de combo a la hora de confugurar las filas 
  * visibles en tablas
  */
  public numFilasCombo(){
    let resolucion = window.screen.width;
      
    if(resolucion < 500){
      this.numFilas = NUM_FILE_TABLE_OPTIONS.MOVIL;
    } else if(resolucion > 500 && resolucion < 750) {
      this.numFilas = NUM_FILE_TABLE_OPTIONS.TABLET;
    } else{
      this.numFilas = NUM_FILE_TABLE_OPTIONS.PC;
    }
  }
}
